import { formatDateLocal, getDaysSince } from "../../../../../lib/script";
import Tag from "../../../../fragments/Tag";
import BlockHeaderComponent from "./BlockHeaderComponent";

export default function CaseDrawerSection({classes, goToCaseTabHandler, drawerData = {}}) {
    const row = drawerData ?? {}
    return <div className={classes.block}>
        <BlockHeaderComponent title="Case data" goToCaseTabHandler={goToCaseTabHandler} />
        {/* <div className={classes.block_header}>
            <h3>Case data</h3>
            <button onClick={goToCaseTabHandler}><i className='ti ti ti-arrow-up-right'></i></button>
        </div> */}
        <div className={classes.block_body}>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Days Treating</div>
                <div className={classes.value}>{getDaysSince(row.case?.initial_treatment)}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Property Damage</div>
                <div className={classes.value}>{row.additional?.property_damage}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Date of Incident</div>
                <div className={classes.value}>
                    {row.case?.incident_date ? formatDateLocal(row.case.incident_date) : ''}
                </div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>Incident State</div>
                <div className={classes.value}>{row.case?.state}</div>
            </div>
            <div className={classes.block_body_row}>
                <div className={classes.label}>People involved in the accident</div>
                <div className={classes.value}>{row.additional?.people_involved}</div>
            </div>

            <div className={classes.separator}></div>

            <div className={classes.block_body_row}>
                <div className={classes.label}>Date of Birth</div>
                <div className={classes.value}>
                    {row.patient?.dob ? formatDateLocal(row.patient?.dob) : ''}
                    {row.patient?.is_minor ? <Tag>Minor</Tag> : ''}
                </div>
            </div>

            {row.patient?.guardian_name && <div className={classes.block_body_row}>
                <div className={classes.label}>Guardian</div>
                <div className={classes.value}>{row.patient?.guardian_name}</div>
            </div>}
        </div>
    </div>
}